// 入外区分　要共通科。クラス名も適切なものに変更してください！（DBは、InOutTypeで作ってる）
export enum InOutKinds {
  None = 0,
  In = 1, // 入院
  Out = 2, // 外来
}

export class InOutKindsName {

  static getDisplayName(value: InOutKinds) {
    if (value === InOutKinds.None) { return ""; }
    if (value === InOutKinds.In) { return "入院"; }
    if (value === InOutKinds.Out) { return "外来"; }

    return "";
  }
}
